import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {NotificationType} from './redux/actions.notifications.types';

export default class Notification extends Component {
  constructor(props) {
    super(props);
    this.dismiss = this.dismiss.bind(this);
  }

  componentDidMount() {
    const {notification, dismiss, timeout} = this.props;

    this.dismissNotification = setTimeout(() => {
      dismiss(notification);
    }, timeout);
  }

  dismiss() {
    this.props.dismiss(this.props.notification);
    clearTimeout(this.dismissNotification);
  }

  render() {
    const {notification} = this.props;

    if (!notification) {
      return null;
    }

    //can use enum key or value
    const classes = NotificationType[notification.type] || notification.type;

    return (
      <div data-alert className={'alert-box ' + classes}>
        {notification.message}
        <a className="close" onClick={this.dismiss}>&times;</a>
      </div>
    );
  }
}


Notification.displayName = 'Notification';
Notification.propTypes = {
  notification: PropTypes.object.isRequired,
  timeout: PropTypes.number,
  dismiss: PropTypes.func
};
Notification.defaultProps = {
  timeout: 6000
};



// WEBPACK FOOTER //
// ./shared/common/Notification.jsx